import * as React from 'react';

import cn from 'classnames';

type IGridProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Grid: React.FC<IGridProps & { fluid?: boolean }> = ({ fluid = false, className, children }) => (
  <div className={cn(fluid ? 'container-fluid' : 'container', className)}>{children}</div>
);
